export default {
  selectSurvey: {
    heading: 'Umfrage auswählen',
    headingDefault: 'Standardumfrage auswählen',
    noDefault: 'Keine Standardumfrage'
  }
};